import React, { useState, useEffect } from 'react';
import { getMyCacsData, updateCaCsData } from '../../../controller/agent_data_controller';

export const ManageProfileCACS = () => {
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);

    // Editable fields
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [timezone, setTimezone] = useState('');

    useEffect(() => {
        const fetchProfile = async () => {
            setLoading(true);
            const data = await getMyCacsData();
            if (data) {
                setProfileData(data);
                setName(data.name || '');
                setPhone(data.phone || '');
                setTimezone(data.timezone || 'Asia/Kolkata');
            }
            setLoading(false);
        };
        fetchProfile();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!profileData) return;

        if (phone.length !== 10) {
            alert("Please enter a valid 10-digit mobile number.");
            return;
        }

        setUpdating(true);
        // We only pass the fields we want to update
        const updatedData = {
            name: name,
            phone: phone,
            timezone: timezone,
            // Keep existing non-editable fields to prevent accidental overwrites if backend expects them
            role: profileData.role,
            email: profileData.email,
            specialization: profileData.specialization,
            registrationNumber: profileData.registrationNumber
        };

        const result = await updateCaCsData(profileData.id, updatedData, { certificate: null, idProof: null });

        if (result === 'updated') {
            alert('Profile updated successfully');
        } else {
            alert('Failed to update profile: ' + result);
        }
        setUpdating(false);
    };

    if (loading) return <div style={{ padding: '30px' }}>Loading profile data...</div>;
    if (!profileData) return <div style={{ padding: '30px', color: 'red' }}>Error loading profile data.</div>;

    return (
        <div style={{ padding: '30px' }}>
            <h2 className="services-title">Edit Profile</h2>
            <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                maxWidth: '600px'
            }}>
                <form onSubmit={handleSubmit}>
                    {/* Read-only fields */}
                    <div style={{ display: 'flex', gap: '40px', marginBottom: '15px' }}>
                        <div style={{ flex: 1 }}>
                            <label style={{ display: 'block', marginBottom: '8px', color: '#666' }}>Role:</label>
                            <input type="text" value={profileData.role || ''} disabled style={{ width: '100%', padding: '10px', backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '6px' }} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label style={{ display: 'block', marginBottom: '8px', color: '#666' }}>Email:</label>
                            <input type="email" value={profileData.email || ''} disabled style={{ width: '100%', padding: '10px', backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '6px' }} />
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '40px', marginBottom: '20px' }}>
                        <div style={{ flex: 1 }}>
                            <label style={{ display: 'block', marginBottom: '8px', color: '#666' }}>Specialization:</label>
                            <input type="text" value={profileData.specialization || ''} disabled style={{ width: '100%', padding: '10px', backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '6px' }} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label style={{ display: 'block', marginBottom: '8px', color: '#666' }}>Reg. Number:</label>
                            <input type="text" value={profileData.registrationNumber || ''} disabled style={{ width: '100%', padding: '10px', backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '6px' }} />
                        </div>
                    </div>

                    <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '20px 0' }} />

                    {/* Editable fields */}
                    <div style={{ display: 'flex', gap: '40px', marginBottom: '25px' }}>
                        <div style={{ flex: 1 }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Name:</label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Phone:</label>
                            <input
                                type="tel"
                                value={phone}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '');
                                    if (val.length <= 10) setPhone(val);
                                }}
                                minLength="10"
                                maxLength="10"
                                required
                                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={updating}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#3765A5',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: updating ? 'not-allowed' : 'pointer',
                            fontSize: '16px',
                            fontWeight: '500'
                        }}
                    >
                        {updating ? 'Saving...' : 'Save Profile Details'}
                    </button>
                </form>
            </div>
        </div>
    );
};
